module.exports = __webpack_public_path__ + "static/media/propellerhat-1024x512.5355076c.png";